module.exports = __webpack_public_path__ + "static/media/planta_presionado.fe9031c8.svg";